
  import { Component, Vue } from 'vue-property-decorator';
  import { Getter, Action } from 'vuex-class';

  import Header from '../../types/app/headers/header';
  import GeneralHeader from '../../types/app/headers/GeneralHeader';
  import GenericFilter from '../../components/generics/GenericFilter.vue';

  import Endpoint from '../../utils/endpoint';
  import { debounce } from 'lodash';
  import { Watch } from 'vue-property-decorator';
  import qs from 'qs';
  import Filter from '@/src/types/app/application/filter';

  @Component({
    components: {
      GenericFilter
    }
  })
  export default class EntityRelationClassifications extends Vue {
    endpoint = new Endpoint();
    headers: Array<Header> = GeneralHeader.header;

    @Getter('canCreate', { namespace: 'auth' }) canCreate!: boolean;
    @Getter('canRead', { namespace: 'auth' }) canRead!: boolean;
    @Getter('getFilter', { namespace: 'app' }) filter!: Filter;

    @Action('setFilter', { namespace: 'app' }) setFilter!: any;
    @Action('setFilterSkip', { namespace: 'app' }) setFilterSkip!: any;

    debounceSearch: any = null;
    loading = false;
    loadingMore = false;
    hasMore = true;

    entityRelationClassifications: any[] = [];

    created() {
      this.debounceSearch = debounce(this.getEntityRelationClassifications, 1000);
      this.getEntityRelationClassifications();
    }

    @Watch('filter.search')
    private async filtering() {
      if (this.filter.search != null) {
        this.setFilterSkip(0);

        this.entityRelationClassifications = [];
        this.debounceSearch();
      }
    }

    getByFilter() {
      this.setFilterSkip(0);
      this.entityRelationClassifications = [];

      this.getEntityRelationClassifications();
    }

    cleanFilter() {
      this.setFilter({
        skip: 0,
        take: 10,
        search: null,
        active: null
      });

      this.entityRelationClassifications = [];
      this.getEntityRelationClassifications();
    }

    getEntityRelationClassifications(): void {
      this.loading = true;

      this.$http
        .get(`${this.endpoint.entityRelationClassification.getByFilter}?${qs.stringify(this.filter)}`)
        .then(res => {
          res.data.data.forEach(entityRelationClassification => {
            entityRelationClassification.activeText =
              entityRelationClassification.active == true ? 'Active' : 'Inactive';
            this.entityRelationClassifications.push(entityRelationClassification);
          });

          this.hasMore = res.data.data.length >= 10;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log('error response', err);
        });
    }

    getMore(): void {
      const skip = (this.filter.skip += 1);

      this.setFilterSkip(skip);
      this.getEntityRelationClassifications();
    }

    goToDetail(item: any): void {
      this.$router.push({
        name: 'EntityRelationClassification',
        params: { id: item.id }
      });
    }
  }
